export enum DataType {
  TEXT = "text",
  INPUT_TEXT = "inputText",
  NUMBER = "number",
  INPUT_NUMBER = "inputNumber",
  TEXT_NUMBER = "textNumber",
  CHECKBOX = "checkbox",
  LINK = "link",
  DATE = "date",
  DROPDOWN_LIST = "dropdownList",
}

export enum Alginment {
  Left = "left",
  Center = "center",
  Right = "right",
}

export enum LoadingMessages {
  Searching = "検索中・・・",
  Loading = "読込中・・・",
  Registing = "登録中・・・",
  Deleting = "削除中・・・",
  Initializing = "初期化中・・・",
}

export const EMPTY_STRING: string = "";

export const MSG_PARAM1: string = "%1";
export const MSG_PARAM2: string = "%2";
export const MSG_PARAM3: string = "%3";

export const URL_PATH_SEPARATOR = "/";

export const DEFAULT_KEYPAD_MAX_COL = 10;
export const BARCODE_LENGTH = 13;

export const MAX_RECORD: number = 1000;

export class SystemParameter {
  public static readonly AP0001 = "AP0001";
  public static readonly AP0002 = "AP0002";
  public static readonly CM0001 = "CM0001";
  public static readonly CM0002 = "CM0002";
  public static readonly CM0003 = "CM0003";
  public static readonly CM0004 = "CM0004";
  public static readonly CM0005 = "CM0005";
  public static readonly CM0006 = "CM0006";
  public static readonly CM0007 = "CM0007";
  public static readonly IV0001 = "IV0001";
  public static readonly MT0001 = "MT0001";
  public static readonly MT0002 = "MT0002";
  public static readonly MT0003 = "MT0003";
  public static readonly MT0004 = "MT0004";
  public static readonly MT0005 = "MT0005";
  public static readonly MT0006 = "MT0006";
  public static readonly MT0007 = "MT0007";
  public static readonly MT0008 = "MT0008";
  public static readonly MT0009 = "MT0009";
  public static readonly MT0010 = "MT0010";
  public static readonly MT0011 = "MT0011";
  public static readonly MT0012 = "MT0012";
  public static readonly MT0013 = "MT0013";
  public static readonly MT0014 = "MT0014";
  public static readonly MT0015 = "MT0015";
  public static readonly OR0001 = "OR0001";
  public static readonly OR0002 = "OR0002";
  public static readonly OR0003 = "OR0003";
  public static readonly OR0004 = "OR0004";
  public static readonly OR0005 = "OR0005";
  public static readonly OR0006 = "OR0006";
  public static readonly PR0001 = "PR0001";
  public static readonly PR0002 = "PR0002";
  public static readonly PR0003 = "PR0003";
  public static readonly PR0004 = "PR0004";
  public static readonly PR0005 = "PR0005";
  public static readonly PR0006 = "PR0006";
  public static readonly PR0007 = "PR0007";
  public static readonly PR0008 = "PR0008";
  public static readonly PR0009 = "PR0009";
  public static readonly PR0010 = "PR0010";
  public static readonly PR0011 = "PR0011";
  public static readonly ST0001 = "ST0001";
  public static readonly ST0002 = "ST0002";
  public static readonly ST0003 = "ST0003";
  public static readonly ST0004 = "ST0004";
  public static readonly ST0005 = "ST0005";
  public static readonly ST0006 = "ST0006";
  public static readonly ST0007 = "ST0007";
  public static readonly ST0008 = "ST0008";
  public static readonly ST0009 = "ST0009";
}
